import React, { useEffect }  from "react";
import { Button, Result } from "antd";

function NotFoundPagePage() {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Xin lỗi, trang bạn tìm kiếm không tồn tại."
      extra={<Button type="primary">Quay lại Trang chủ</Button>}
    />
  )
}

export default NotFoundPagePage;
